<div class="ssa-dialog">

  <div class="ssa-header" mat-dialog-title>
    <div class="ssa-title">
      <mat-icon>verified</mat-icon>
      <div>
        <h2>Registros SSA</h2>
        <span class="ssa-sub">{{ data.identifier || 'Equipo' }}</span>
      </div>
    </div>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  <mat-dialog-content class="ssa-body">

    @if (rows().length === 0) {
      <div class="ssa-empty">
        <mat-icon>playlist_add</mat-icon>
        <p>Aún no hay registros SSA. Agrega uno para empezar.</p>
      </div>
    }

    @for (row of rows(); track $index) {
      <div class="ssa-card">
        <div class="ssa-card-head">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="std-field">
            <mat-label>Estándar</mat-label>
            <mat-select [value]="row.reg_standar"
                        (selectionChange)="patch($index, 'reg_standar', $event.value)">
              @for (s of standards; track s) {
                <mat-option [value]="s">{{ s }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <button mat-icon-button color="warn" matTooltip="Eliminar registro"
                  (click)="remove($index)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <div class="ssa-card-row">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="text-field">
            <mat-label>Referencia</mat-label>
            <input matInput [value]="row.regNumber ?? ''"
                   (input)="patch($index, 'regNumber', $any($event.target).value)">
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="text-field">
            <mat-label>Vigencia</mat-label>
            <input matInput type="date" [value]="row.reg_validity ?? ''"
                   (change)="patch($index, 'reg_validity', $any($event.target).value || null)">
          </mat-form-field>

          <div class="pdf-cell">
            <span class="pdf-label"><mat-icon>description</mat-icon> Documentación</span>
            @if (row.uploadedByName || row.uploadedAt) {
              <span class="pdf-uploader">
                Subido por {{ row.uploadedByName || 'usuario' }}
                @if (row.uploadedAt) { · {{ row.uploadedAt | date:'dd/MM/yyyy HH:mm' }} }
              </span>
            }
            <div class="pdf-actions">
              @if (hasPdf($index)) {
                <button mat-icon-button color="primary" matTooltip="Ver PDF"
                        (click)="viewPdf(row.pdf)">
                  <mat-icon>visibility</mat-icon>
                </button>
              }
              <button mat-icon-button color="accent"
                      [matTooltip]="(hasPdf($index) ? 'Reemplazar' : 'Cargar') + ' PDF'"
                      (click)="openFileManager($index)">
                <mat-icon>{{ hasPdf($index) ? 'cloud_sync' : 'cloud_upload' }}</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    <button mat-stroked-button color="primary" class="add-btn" (click)="add()">
      <mat-icon>add</mat-icon> Agregar registro SSA
    </button>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="saving()">Cancelar</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="saving()">
      @if (saving()) {<mat-spinner diameter="18"></mat-spinner>} @else {<mat-icon>save</mat-icon>}
      <span>Guardar</span>
    </button>
  </mat-dialog-actions>
</div>
